var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaystoreIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 133 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11_471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.492 43.6666H14.4933C12.2054 43.6666 10.3334 41.7916 10.3334 39.5V14.5C10.3334 12.2083 12.2054 10.3333 14.4933 10.3333H118.492C120.78 10.3333 122.652 12.2083 122.652 14.5V39.5C122.652 41.7916 120.78 43.6666 118.492 43.6666Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.492 10.3333H14.4933C12.2054 10.3333 10.3334 12.2083 10.3334 14.5V39.5C10.3334 41.7916 12.2054 43.6666 14.4933 43.6666H118.492C120.78 43.6666 122.652 41.7916 122.652 39.5V14.5C122.652 12.2083 120.78 10.3333 118.492 10.3333ZM118.492 11C120.418 11 121.986 12.5703 121.986 14.5V39.5C121.986 41.43 120.418 43.0003 118.492 43.0003H14.4933C12.5668 43.0003 10.999 41.43 10.999 39.5V14.5C10.999 12.5703 12.5668 11 14.4933 11H118.492Z",
    fill: "url(#paint0_linear_11_471)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7844 18.8696C49.7844 19.5678 49.578 20.1237 49.1646 20.5385C48.695 21.0317 48.083 21.2785 47.3306 21.2785C46.6101 21.2785 45.9975 21.0285 45.4938 20.5277C44.9891 20.0274 44.7373 19.407 44.7373 18.6667C44.7373 17.9261 44.9891 17.3062 45.4938 16.8054C45.9975 16.3052 46.6101 16.0547 47.3306 16.0547C47.6882 16.0547 48.0304 16.1248 48.3554 16.2645C48.6804 16.4044 48.941 16.5903 49.136 16.823L48.6973 17.2627C48.3668 16.8672 47.9118 16.6696 47.3306 16.6696C46.8052 16.6696 46.3509 16.8546 45.9674 17.2247C45.5838 17.5951 45.3921 18.0756 45.3921 18.6667C45.3921 19.258 45.5838 19.7383 45.9674 20.1088C46.3509 20.479 46.8052 20.6638 47.3306 20.6638C47.8881 20.6638 48.3529 20.478 48.7249 20.1056C48.9664 19.863 49.1061 19.5258 49.1434 19.0929H47.3306V18.4923H49.7496C49.773 18.6229 49.7844 18.7482 49.7844 18.8696",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.785 18.8693H49.7018C49.7011 19.5516 49.5022 20.0815 49.1063 20.4793L49.1055 20.48L49.1051 20.4806C48.6505 20.9568 48.066 21.1938 47.3312 21.1948C46.63 21.1938 46.043 20.9542 45.5528 20.4686C45.0638 19.9819 44.822 19.3878 44.821 18.6665C44.822 17.9448 45.0638 17.3511 45.5528 16.8647C46.043 16.3787 46.63 16.1388 47.3312 16.1378C47.678 16.1378 48.0082 16.2056 48.3231 16.3406C48.6383 16.4767 48.8874 16.6551 49.0729 16.8765L49.1366 16.8227L49.0778 16.7638L48.639 17.2039L48.6978 17.2625L48.7619 17.2091C48.4161 16.7941 47.9305 16.5848 47.3312 16.5861C46.7862 16.5854 46.3069 16.7804 45.9103 17.1646C45.51 17.55 45.3088 18.0574 45.3095 18.6665C45.3088 19.2756 45.51 19.783 45.9103 20.1684C46.3069 20.5526 46.7862 20.7476 47.3312 20.7469C47.907 20.7479 48.3979 20.5522 48.7843 20.1642C49.0423 19.9051 49.1886 19.5461 49.227 19.0997L49.2347 19.0092H47.4144V18.5753H49.7502V18.492L49.6683 18.5066C49.6911 18.633 49.7018 18.7531 49.7018 18.8693H49.8682C49.8682 18.7426 49.8565 18.6125 49.832 18.4771L49.8197 18.4086H47.248V19.1759H49.144V19.0926L49.0612 19.0854C49.0245 19.5047 48.8912 19.8205 48.6666 20.0464C48.3091 20.4031 47.8704 20.5792 47.3312 20.5802C46.8252 20.5796 46.396 20.4051 46.0257 20.0486C45.6591 19.6935 45.4768 19.2401 45.4759 18.6665C45.4768 18.0929 45.6591 17.6395 46.0257 17.2843C46.396 16.9279 46.8252 16.7534 47.3312 16.7527C47.8938 16.7541 48.3186 16.9402 48.6342 17.3162L48.6927 17.3859L49.1955 16.8816L49.2494 16.8276L49.2003 16.7693C48.9959 16.5252 48.7235 16.3315 48.3888 16.1876C48.0534 16.0434 47.6995 15.9711 47.3312 15.9711C46.5915 15.9705 45.9533 16.2309 45.4356 16.7462C44.9159 17.2606 44.654 17.9071 44.6546 18.6665C44.654 19.4256 44.9159 20.0724 45.4359 20.5871C45.9533 21.1021 46.5915 21.3621 47.3312 21.3615C48.1015 21.3621 48.7405 21.1059 49.2254 20.5958L49.1651 20.5382L49.224 20.5971C49.655 20.1658 49.8688 19.5831 49.8682 18.8693H49.785M53.6199 16.7807H51.3466V18.3661H53.3967V18.9669H51.3466V20.5522H53.6199V21.1665H50.7057V16.1665H53.6199V16.7807Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6197 16.781V16.6977H51.2631V18.4497H53.3132V18.8837L51.2631 18.8838V20.6358H53.5365V21.0834H50.7887V16.2501H53.5365V16.781H53.6197V16.6977V16.781H53.7029V16.0834H50.6223V21.2501H53.7029V20.4692H51.4295V19.0505H53.4796V18.2831H51.4295V16.8643H53.7029V16.781H53.6197ZM56.3246 21.1668H55.6828V16.781H54.2885V16.1667H57.7189V16.781H56.3246V21.1667",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3247 21.1668V21.0834H55.766V16.6977H54.3719V16.2502H57.6358V16.6977H56.2415V21.1667H56.3247V21.0834V21.1667H56.4079V16.8643H57.8022V16.0834H54.2054V16.8643H55.5997V21.2501H56.4079V21.1667H56.3247M60.2009 21.1668V16.1667H60.8422V21.1667H60.2009",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2004 21.1668H60.2837V16.2501H60.7584V21.0834H60.2004V21.1667H60.2837H60.2004V21.2501H60.9249V16.0834H60.1173V21.2501H60.2004V21.1667M63.687 21.1668H63.0451V16.781H61.6509V16.1667H65.0813V16.781H63.687V21.1667",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6879 21.1668V21.0834H63.1293V16.6976H61.7351V16.2502H64.9989V16.6976H63.6048V21.1667H63.6879V21.0834V21.1667H63.7712V16.8643H65.1654V16.0834H61.5687V16.8643H62.9629V21.2501H63.7712V21.1667H63.6879M68.3894 20.1021C68.7589 20.4767 69.2109 20.6638 69.7456 20.6638C70.2802 20.6638 70.7325 20.4767 71.1014 20.1021C71.4713 19.7274 71.6565 19.2484 71.6565 18.6667C71.6565 18.0851 71.4713 17.6062 71.1014 17.2316C70.7325 16.8569 70.2802 16.6696 69.7456 16.6696C69.2109 16.6696 68.7589 16.8569 68.3894 17.2316C68.0204 17.6062 67.8353 18.0851 67.8353 18.6667C67.8353 19.2484 68.0204 19.7274 68.3894 20.1021ZM71.5759 20.5206C71.0851 21.0261 70.4749 21.2785 69.7456 21.2785C69.0156 21.2785 68.4055 21.0261 67.9159 20.5206C67.4248 20.0157 67.1804 19.3976 67.1804 18.6667C67.1804 17.9359 67.4248 17.3177 67.9159 16.8129C68.4056 16.3073 69.0156 16.0547 69.7456 16.0547C70.4709 16.0547 71.0796 16.3087 71.5727 16.8162C72.065 17.3237 72.3114 17.9405 72.3114 18.6667C72.3114 19.3976 72.0656 20.0157 71.5759 20.5206Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3886 20.1017L68.3295 20.1603C68.7127 20.55 69.1908 20.7479 69.7449 20.7469C70.2986 20.7479 70.7774 20.55 71.1599 20.1603C71.5456 19.7703 71.7396 19.2657 71.739 18.6665C71.7396 18.0672 71.5456 17.5626 71.1599 17.1726C70.7774 16.783 70.2986 16.5851 69.7449 16.5861C69.1908 16.5851 68.7127 16.783 68.3295 17.1726C67.9447 17.5626 67.7503 18.0672 67.7513 18.6665C67.7503 19.2657 67.9447 19.7703 68.3295 20.1603L68.3886 20.1017L68.4478 20.0431C68.0949 19.6834 67.9184 19.2309 67.9177 18.6665C67.9184 18.1021 68.0949 17.6496 68.4478 17.2898C68.804 16.9301 69.2294 16.7537 69.7449 16.7527C70.26 16.7537 70.6863 16.9301 71.0416 17.2898C71.3952 17.6496 71.5716 18.1021 71.5723 18.6665C71.5716 19.2309 71.3952 19.6834 71.0416 20.0431C70.6863 20.4028 70.26 20.5792 69.7449 20.5802C69.2294 20.5792 68.804 20.4028 68.4478 20.0431L68.3886 20.1017ZM71.5752 20.5203L71.5157 20.4624C71.0387 20.952 70.4553 21.1938 69.7449 21.1948C69.0341 21.1938 68.4507 20.952 67.9746 20.4624L67.9723 20.4598L67.9746 20.4624C67.4985 19.9711 67.2636 19.3787 67.2629 18.6665C67.2636 17.9542 67.4985 17.3618 67.9746 16.8706C68.4507 16.381 69.0341 16.1388 69.7449 16.1378C70.4507 16.1388 71.0328 16.382 71.5125 16.8741C71.9902 17.3676 72.2266 17.9591 72.2276 18.6665C72.2266 19.3787 71.9909 19.9711 71.5157 20.4624L71.5752 20.5203L71.635 20.5782C72.1394 20.0594 72.3945 19.4158 72.394 18.6665C72.3946 17.9214 72.1384 17.2791 71.6317 16.758C71.1248 16.2348 70.4897 15.9702 69.7449 15.9711C68.9961 15.9702 68.3591 16.2336 67.8553 16.7547V16.7544C67.35 17.2736 67.0958 17.9171 67.0965 18.6665C67.0958 19.4158 67.35 20.0594 67.8553 20.5786L67.8576 20.5809L67.8553 20.5782C68.3591 21.0994 68.9961 21.3621 69.7449 21.3615C70.4933 21.3621 71.1303 21.0994 71.635 20.5782L71.5752 20.5203ZM73.2109 21.1665V16.1665H73.9916L76.4176 20.0561H76.4453L76.4176 19.0926V16.1665H77.0596V21.1664H76.3901L73.8518 17.0883H73.8242L73.8518 18.0522V21.1664H73.211",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2112 21.1668H73.2945V16.2501H73.9457L76.3718 20.1397H76.531L76.5011 19.0917V16.2502H76.9766V21.0834H76.4365L73.8983 17.0053H73.739L73.769 18.0539V21.0834H73.2113V21.1667H73.2945H73.2113V21.2501H73.9353V18.0512L73.9077 17.0864L73.8245 17.0887V17.172H73.8521V17.0887L73.7816 17.1329L76.3442 21.2501H77.143V16.0834H76.3348V19.0938L76.3624 20.0587L76.4456 20.0564V19.9731H76.418V20.0564L76.4885 20.0122L74.038 16.0834H73.1281V21.2501H73.2113V21.1667M99.3025 35.3334H100.855V24.9158H99.3025V35.3334ZM113.286 28.6685L111.507 33.1851H111.453L109.606 28.6684H107.934L110.703 34.9812L109.124 38.4927H110.744L115.013 28.6684L113.286 28.6685ZM104.482 34.1502C103.973 34.1502 103.264 33.8957 103.264 33.2655C103.264 32.4613 104.148 32.1532 104.91 32.1532C105.593 32.1532 105.913 32.3006 106.328 32.5018C106.208 33.4666 105.378 34.1502 104.482 34.1502ZM104.669 28.4406C103.545 28.4406 102.381 28.9366 101.899 30.0357L103.278 30.6118C103.572 30.0357 104.12 29.8477 104.696 29.8477C105.498 29.8477 106.315 30.3305 106.328 31.1883V31.2954C106.047 31.1346 105.446 30.8933 104.709 30.8933C103.224 30.8933 101.712 31.7107 101.712 33.2387C101.712 34.6327 102.929 35.5307 104.294 35.5307C105.338 35.5307 105.913 35.0616 106.275 34.5122H106.328V35.3162H107.827V31.322C107.827 29.4728 106.449 28.4406 104.669 28.4406ZM95.075 29.9366H92.8667V26.3657H95.075C96.235 26.3657 96.8942 27.3282 96.8942 28.1512C96.8942 28.9584 96.235 29.9366 95.075 29.9366ZM95.035 24.9158H91.315V35.3334H92.8667V31.3865H95.035C96.755 31.3865 98.4467 30.1387 98.4467 28.1512C98.4467 26.1636 96.755 24.9158 95.035 24.9158ZM74.7501 34.1522C73.6776 34.1522 72.7796 33.2527 72.7796 32.0173C72.7796 30.7691 73.6776 29.8559 74.7501 29.8559C75.809 29.8559 76.64 30.769 76.64 32.0173C76.64 33.2527 75.809 34.1522 74.7501 34.1522ZM76.5327 29.2518H76.479C76.1307 28.8357 75.4602 28.4598 74.6159 28.4598C72.8466 28.4598 71.2249 30.0171 71.2249 32.0173C71.2249 34.0044 72.8465 35.5483 74.6159 35.5483C75.4602 35.5483 76.1307 35.1723 76.479 34.7429H76.5327V35.253C76.5327 36.6092 75.809 37.3342 74.6429 37.3342C73.6912 37.3342 73.1015 36.6492 72.8599 36.0721L71.5064 36.6359C71.895 37.5757 72.9272 38.7303 74.6429 38.7303C76.4657 38.7303 78.0072 37.656 78.0072 35.0382V28.6747H76.5327V29.2518ZM79.0794 35.3334H80.6342V24.9154H79.0794V35.3334ZM82.9263 31.8967C82.886 30.5271 83.9851 29.8292 84.7759 29.8292C85.3925 29.8292 85.915 30.1378 86.0892 30.5812L82.9263 31.8967ZM87.7517 30.7152C87.4567 29.9229 86.5584 28.4598 84.7222 28.4598C82.8994 28.4598 81.3849 29.8962 81.3849 32.004C81.3849 33.9911 82.886 35.5483 84.8965 35.5483C86.5184 35.5483 87.4567 34.5547 87.8459 33.9776L86.6392 33.1719C86.2375 33.7627 85.6875 34.1522 84.8965 34.1522C84.1057 34.1522 83.5429 33.7895 83.1808 33.0782L87.9125 31.118L87.7517 30.7152ZM50.0557 29.5473V31.0509H53.6478C53.5405 31.8967 53.2591 32.5142 52.8301 32.9437C52.3075 33.4676 51.4899 34.0447 50.0556 34.0447C47.844 34.0447 46.115 32.2592 46.115 30.044C46.115 27.8289 47.844 26.0432 50.0557 26.0432C51.2487 26.0432 52.1197 26.5132 52.7631 27.1172L53.822 26.0567C52.924 25.1973 51.731 24.5396 50.0557 24.5396C47.0264 24.5396 44.4797 27.0099 44.4797 30.044C44.4797 33.0782 47.0264 35.5483 50.0557 35.5483C51.691 35.5483 52.924 35.0116 53.889 34.0044C54.8809 33.0108 55.1893 31.6147 55.1893 30.4871C55.1893 30.1378 55.1626 29.8158 55.1087 29.5473H50.0557ZM59.2732 34.1522C58.2007 34.1522 57.2758 33.266 57.2758 32.004C57.2758 30.7286 58.2007 29.8559 59.2732 29.8559C60.3453 29.8559 61.2702 30.7286 61.2702 32.004C61.2702 33.2661 60.3453 34.1522 59.2732 34.1522ZM59.2732 28.4598C57.316 28.4598 55.721 29.9499 55.721 32.004C55.721 34.0447 57.316 35.5483 59.2732 35.5483C61.23 35.5483 62.825 34.0447 62.825 32.004C62.825 29.9499 61.23 28.4598 59.2732 28.4598ZM67.0216 34.1522C65.9496 34.1522 65.0245 33.266 65.0245 32.004C65.0245 30.7286 65.9496 29.8559 67.0217 29.8559C68.0939 29.8559 69.0188 30.7286 69.0188 32.004C69.0188 33.2661 68.0939 34.1522 67.0217 34.1522H67.0216ZM67.0216 28.4598C65.0646 28.4598 63.4699 29.9499 63.4699 32.004C63.4699 34.0447 65.0646 35.5483 67.0217 35.5483C68.9785 35.5483 70.5736 34.0447 70.5736 32.004C70.5736 29.9499 68.9785 28.4598 67.0217 28.4598H67.0216Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.076 16.6758C18.7967 16.9282 18.6301 17.349 18.6301 17.9077V17.7813V36.2156V36.0942C18.6301 36.6101 18.773 37.0085 19.0151 37.2651L19.077 37.3243V37.3246C19.2729 37.5017 19.5241 37.5957 19.8121 37.5954C20.0935 37.5954 20.41 37.5056 20.7442 37.3158L32.8206 30.4431L36.9688 28.0821C37.4957 27.7823 37.7915 27.3956 37.8409 27.0017V27.0001C37.7915 26.6052 37.4957 26.2188 36.9689 25.919L32.8203 23.5583L20.7442 16.6856C20.4094 16.4955 20.0926 16.4053 19.8105 16.4053C19.5228 16.4053 19.2719 16.4991 19.076 16.6758H19.076Z",
    fill: "#00C1FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.077 37.3247L19.0151 37.2654C18.773 37.0089 18.6301 36.6105 18.6301 36.0946V36.216V17.7863V17.908C18.6301 17.3494 18.7967 16.9285 19.076 16.6762L29.3841 27.0008L19.077 37.3247Z",
    fill: "url(#paint1_linear_11_471)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.821 30.4431L29.3845 27.0005L32.8207 23.5584L36.9692 25.9191C37.496 26.2189 37.7918 26.6053 37.8412 27.0001V27.0017C37.7918 27.3956 37.496 27.7824 36.9692 28.0821L32.821 30.4431Z",
    fill: "url(#paint2_linear_11_471)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8128 37.5957C19.5249 37.596 19.2736 37.5019 19.0777 37.3248V37.3246L29.3849 27.0007L32.8214 30.4433L20.7449 37.3161C20.4107 37.5058 20.0941 37.5957 19.8128 37.5957Z",
    fill: "url(#paint3_linear_11_471)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3847 27.0008L19.0764 16.6762C19.2724 16.4995 19.5234 16.4057 19.8109 16.4057C20.093 16.4057 20.4099 16.4958 20.7447 16.686L32.8209 23.5587L29.3846 27.0008",
    fill: "url(#paint4_linear_11_471)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8135 37.7177C19.5255 37.7177 19.274 37.6236 19.078 37.4466L19.0776 37.4469C19.0769 37.4461 19.076 37.4453 19.075 37.4446L19.0215 37.3922C19.0198 37.3906 19.0182 37.3886 19.0162 37.3867L19.078 37.3248C19.274 37.5019 19.5252 37.596 19.8132 37.5956C20.0945 37.5956 20.4111 37.5058 20.7452 37.3161L32.8217 30.4433L32.8991 30.5209L32.8207 30.5654L20.7452 37.4378C20.4407 37.6106 20.1511 37.7008 19.8895 37.7158C19.8642 37.7171 19.8388 37.7177 19.8135 37.7177Z",
    fill: "url(#paint5_linear_11_471)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0151 37.387C18.773 37.1304 18.6301 36.7323 18.6301 36.2161V36.0947C18.6301 36.6106 18.773 37.009 19.0151 37.2656L19.077 37.3248L19.0151 37.387Z",
    fill: "url(#paint6_linear_11_471)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8985 30.5209L32.8212 30.4433L36.9694 28.0824C37.4962 27.7827 37.7919 27.3959 37.8414 27.002C37.8414 27.1465 37.8092 27.2911 37.7452 27.4317C37.6161 27.7152 37.3575 27.9832 36.9694 28.2042L32.8985 30.5209Z",
    fill: "url(#paint7_linear_11_471)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8413 27.0004C37.7919 26.6056 37.4961 26.2191 36.9693 25.9193L32.8208 23.5586L32.8981 23.4811H32.8984L36.9693 25.7979C37.5501 26.1286 37.8409 26.5645 37.8413 27.0004Z",
    fill: "url(#paint8_linear_11_471)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6301 17.9078V17.7805C18.6301 17.7346 18.6313 17.6897 18.6337 17.6461V17.6441C18.6337 17.6435 18.6337 17.6428 18.6339 17.6422V17.6372C18.659 17.1928 18.7967 16.8462 19.0151 16.6148L19.076 16.676C18.7967 16.9283 18.6301 17.3492 18.6301 17.9078Z",
    fill: "url(#paint9_linear_11_471)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8214 23.5584L20.7452 16.6856C20.4105 16.4956 20.0936 16.4054 19.8115 16.4054C19.5239 16.4054 19.273 16.4991 19.077 16.6759L19.0162 16.6147C19.0352 16.5946 19.055 16.5751 19.0754 16.5565C19.076 16.5558 19.077 16.5551 19.0777 16.5545C19.272 16.3791 19.5204 16.2853 19.8054 16.2836H19.8115C20.0936 16.2836 20.4105 16.3738 20.7452 16.564L32.8991 23.4806L32.8988 23.4809L32.8214 23.5584Z",
    fill: "url(#paint10_linear_11_471)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11_471",
    x: 0.333374,
    y: 0.333313,
    width: 132.318,
    height: 53.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.341176 0 0 0 0 0.490196 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_471"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_471",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_471",
    x1: 137.974,
    y1: 5.22283,
    x2: 29.9235,
    y2: 36.0074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF6823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20419A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11_471",
    x1: 25.2176,
    y1: 17.5915,
    x2: 16.3343,
    y2: 26.4892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11_471",
    x1: 38.4831,
    y1: 26.941,
    x2: 18.3515,
    y2: 26.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11_471",
    x1: 30.9969,
    y1: 30.2738,
    x2: 15.9434,
    y2: 45.2414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11_471",
    x1: 16.4197,
    y1: 15.1456,
    x2: 23.1287,
    y2: 21.8266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11_471",
    x1: 30.9897,
    y1: 32.6618,
    x2: 18.9341,
    y2: 44.7369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11_471",
    x1: 20.0033,
    y1: 17.5916,
    x2: 12.1772,
    y2: 25.4304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00B8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11_471",
    x1: 38.4833,
    y1: 27.0012,
    x2: 18.3516,
    y2: 27.0012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#E0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#E09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11_471",
    x1: 38.4832,
    y1: 27.0012,
    x2: 18.3516,
    y2: 27.0012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFBC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11_471",
    x1: 19.9948,
    y1: 17.6054,
    x2: 12.4569,
    y2: 24.8284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#40B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#40CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#40DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_11_471",
    x1: 16.4053,
    y1: 17.3286,
    x2: 21.7886,
    y2: 22.7208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#62BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#50DB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#44ED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F498"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreIcon);
export default __webpack_public_path__ + "static/media/playstore-icon.6a5019f44658cc08b3580f2a9d517500.svg";
export { ForwardRef as ReactComponent };